import { colors, sizing } from '@chillibean/component-library';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const tabLinksPropTypes = {
  tabRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
    }),
  ).isRequired,
};

export function TabLinks(props) {
  const { links, match } = props;
  const { path } = match || {};

  const getRedirectionLink = (link) => link.path.replace(':study_protocol_id', match.params.study_protocol_id);

  return (
    <LinksContainer>
      {links.map((link) => (
        <StyledLink
          key={link.path}
          className={clsx({
            active: path === link.path,
            link: true,
          })}
          to={getRedirectionLink(link)}
        >
          {link.name}
        </StyledLink>
      ))}
    </LinksContainer>
  );
}

const LinksContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${sizing.medium} ${sizing.xlarge};
  border-bottom: 1px solid ${colors.grey.admin};

  > a:not(:last-child) {
    margin-right: ${sizing.large};
  }
`;

const StyledLink = styled(Link)`
  &.link {
    font-weight: normal;
    text-decoration: none;
    color: ${colors.grey.strong};

    &:hover {
      text-decoration: underline;
      transition: text-decoration 0.3s ease-in-out;
    }
  }

  &.active {
    font-weight: bold;
    text-decoration: underline;
    color: ${colors.black.primary};
  }
`;

TabLinks.propTypes = {
  ...tabLinksPropTypes.isRequired,
};

export default TabLinks;
